import { render, staticRenderFns } from "./optimization.vue?vue&type=template&id=036f7594&scoped=true&"
import script from "./optimization.vue?vue&type=script&lang=js&"
export * from "./optimization.vue?vue&type=script&lang=js&"
import style0 from "./optimization.vue?vue&type=style&index=0&id=036f7594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f7594",
  null
  
)

export default component.exports